import React, { useState, useEffect } from "react"
import Modal from "aldoo-ra/Modal"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import Spinner from "aldoo-ra/Spinner"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import { buildRetentionOptions } from "./utils"
import { GetQuota } from "../FileShareFeature/api"

// Pro-only extend (recovery). Durations come from the server (plan feature
// matrix); the share can be extended up to `extends_left` more times.
// A fresh allocation: new expiry from now and the contact budget is reset.
export default function ExtendModal({ share, isOpen, onClose, extending, onExtend }) {
  const texts = TextBundle({ id: "transfer_share_dashboard" })
  const [retentionDays, setRetentionDays] = useState(null)
  const RETENTION_OPTIONS = buildRetentionOptions(retentionDays)
  const [extendDays, setExtendDays] = useState(RETENTION_OPTIONS[0]?.days ?? 3)

  // Pull the server-driven duration options when the modal opens.
  useEffect(() => {
    if (!isOpen) return
    let alive = true
    GetQuota().then((q) => { if (alive && Array.isArray(q?.retentionOptions)) setRetentionDays(q.retentionOptions) }).catch(() => {})
    return () => { alive = false }
  }, [isOpen])

  useEffect(() => {
    if (isOpen) setExtendDays(RETENTION_OPTIONS[0]?.days ?? 3)
  }, [isOpen, share?.orderID, retentionDays]) // eslint-disable-line react-hooks/exhaustive-deps

  const extendsLeft = share?.extends_left ?? 3

  return (
    <Modal variant="meet_compact" isOpen={isOpen} onClose={onClose} mobileFullScreen>
      <div className="p-6 w-full h-full flex flex-col pb-[calc(1.5rem+env(safe-area-inset-bottom))]">
        <Typography variant="h4" className="mb-1">
          {texts?.selectExtendPeriod}
        </Typography>
        <p className="text-sm text-text_secondary mb-1 truncate">{share?.file_name}</p>
        <p className="text-xs text-text_secondary mb-5">
          {texts?.extendDescription}{" "}
          <strong>
            {extendsLeft} {texts?.extendsLeft}
          </strong>
        </p>
        <div className="mt-auto flex flex-col gap-4">
          <div className="flex flex-wrap gap-2">
            {RETENTION_OPTIONS.map((opt) => {
              const active = extendDays === opt.days
              return (
                <button
                  key={opt.days}
                  onClick={() => setExtendDays(opt.days)}
                  className={`flex-1 min-w-[28%] flex flex-col items-center justify-center gap-1 rounded-xl border-2 px-4 py-4 transition-colors ${
                    active ? opt.activeBgColor : opt.color
                  }`}
                >
                  <span className={`text-lg font-semibold ${active ? "text-white" : opt.textColor}`}>
                    {opt.days}
                  </span>
                  <span className={`text-xs font-medium ${active ? "text-white" : opt.textColor}`}>
                    {texts?.days}
                  </span>
                </button>
              )
            })}
          </div>
          <Button onClick={() => onExtend(extendDays)} disabled={extending} variant="primary" className="w-full !h-[65px] mt-1">
            {extending ? <Spinner className="w-[16px] h-[16px]" /> : texts?.extend}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
